export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Streitfall eröffnen"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abbrechen"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Senden"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ein Moderator wird zur Unterstützung hinzukommen. Bitte wählen Sie einen Grund und fügen Sie Beweise bei."])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An Moderator senden"])}
}